import React from 'react';
import { Sparkles, Lock } from 'lucide-react';

interface RewardBannerProps {
  discount: '25%' | '50%';
  available: boolean;
  redeemed?: boolean;
  redeemedAt?: string | null;
}

export default function RewardBanner({ discount, available, redeemed, redeemedAt }: RewardBannerProps) {
  if (redeemed) {
    return (
      <div className="reward-banner-locked" style={{ opacity: 0.7 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <div style={{
              width: '32px',
              height: '32px',
              borderRadius: '10px',
              backgroundColor: '#F0D9E4',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}>
              <Sparkles size={16} color="#C4A0B0" />
            </div>
            <div>
              <p style={{ fontSize: '15px', fontWeight: 600, color: '#8E6B7A' }}>{discount} OFF</p>
              <p style={{ fontSize: '12px', color: '#C4A0B0', marginTop: '1px' }}>
                Redeemed{redeemedAt ? ` · ${redeemedAt}` : ''}
              </p>
            </div>
          </div>
          <span className="badge-reward badge-redeemed">Used</span>
        </div>
      </div>
    );
  }

  if (available) {
    return (
      <div className="reward-banner-active pulse-reward">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <div style={{
              width: '32px',
              height: '32px',
              borderRadius: '10px',
              backgroundColor: '#FFFFFF',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}>
              <Sparkles size={16} color="#1C1C1E" />
            </div>
            <div>
              <p style={{ fontSize: '15px', fontWeight: 700, color: '#1C1C1E' }}>{discount} OFF unlocked ♡</p>
              <p style={{ fontSize: '12px', color: '#8E6B7A', marginTop: '1px' }}>Show this to your stylist</p>
            </div>
          </div>
          <span className="badge-reward badge-available">Ready</span>
        </div>
      </div>
    );
  }

  return (
    <div className="reward-banner-locked">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div style={{
            width: '32px',
            height: '32px',
            borderRadius: '10px',
            backgroundColor: '#F0D9E4',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <Lock size={14} color="#C4A0B0" />
          </div>
          <div>
            <p style={{ fontSize: '15px', fontWeight: 600, color: '#C4A0B0' }}>{discount} OFF</p>
            <p style={{ fontSize: '12px', color: '#C4A0B0', marginTop: '1px' }}>Not yet unlocked</p>
          </div>
        </div>
        <span className="badge-reward badge-locked">Locked</span>
      </div>
    </div>
  );
}